/* animated-svg-container.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDuFDC%7Bborder-radius%3A10px%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._39xV027uCV%7Bwidth%3Acalc(100%25%20-%20var(--ds-space-050%2C%204px))%7D%0A._0jFU0V7uCV%7Bheight%3Acalc(100%25%20-%20var(--ds-space-050%2C%204px))%7D%0A._2IhTon1Y8M%7Btop%3Avar(--ds-space-050%2C4px)%7D%0A._3OE6xY1Y8M%7Bleft%3Avar(--ds-space-050%2C4px)%7D%0A._1llTr6zAOz%7Bfilter%3Ablur(var(--ds-space-100%2C8px))%7D%0A._27HALsnQyn%7Bbackface-visibility%3Ahidden%7D%0A._1VJPca24hy%7Btransform%3Atranslate3d(0%2C0%2C0)%7D%0A._3OE6xYdnbC%7Bleft%3A0%7D%0A._2IhTondnbC%7Btop%3A0%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D");












import { useEffect, useRef } from 'react';
import type { AnimatedSvgContainerProps } from './types';
let namespaceUUID = 0;
const svgStyles = null;
const blurredStyles = null;
const notBlurredStyles = null;

/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */
const AnimatedSvgContainer = ({
  palette,
  isMoving,
  isGlowing,
  className
}: AnimatedSvgContainerProps): JSX.Element => {
  const svgRef = useRef<SVGSVGElement>(null);
  const namespaceId = useRef<number>();
  if (namespaceId.current === undefined) {
    namespaceId.current = namespaceUUID;
    namespaceUUID += 1;
  }
  useEffect(() => {
    if (isMoving) {
      const svg = svgRef.current;

      // Schedule animation to begin before next browser paint
      const beginReq = requestAnimationFrame(() => {
        svg?.querySelectorAll('animate').forEach(node => node.beginElement());
      });
      return () => {
        // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
        // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
        cancelAnimationFrame(beginReq);
        requestAnimationFrame(() => {
          svg?.querySelectorAll('animate').forEach(node => node.endElement());
        });
      };
    }
    return undefined;
  }, [isMoving]);
  return <svg
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  className={ax(["_0bjKvDuFDC _1mT5xdWVPG", isGlowing ? "_39xV027uCV _0jFU0V7uCV _2IhTon1Y8M _3OE6xY1Y8M _1llTr6zAOz _27HALsnQyn _1VJPca24hy" : "_3OE6xYdnbC _2IhTondnbC _39xV02N91d _0jFU0VN91d", className])} ref={svgRef} viewBox="0 0 24 24" preserveAspectRatio="none">
			<defs>
				<linearGradient id={`${namespaceId.current}_lg1`} gradientUnits="userSpaceOnUse" x1="0%" y1="0" x2="400%" y2="0" spreadMethod="reflect">
					<animate begin="indefinite" attributeName="x1" from="0%" to="400%" repeatCount="indefinite" dur="3s" />
					<animate begin="indefinite" attributeName="x2" from="400%" to="800%" repeatCount="indefinite" dur="3s" />
					<stop offset="0" stopColor={palette.blue} />
					<stop offset="0.25" stopColor={palette.teal} />
					<stop offset="0.5" stopColor={palette.yellow} />
					<stop offset="0.75" stopColor={palette.teal} />
					<stop offset="1" stopColor={palette.blue} />
				</linearGradient>
				<linearGradient id={`${namespaceId.current}_lg2`} gradientUnits="userSpaceOnUse" x1="0" y1="-100%" x2="0" y2="300%" spreadMethod="reflect">
					<animate begin="indefinite" attributeName="y1" from="-100%" to="300%" repeatCount="indefinite" dur="3s" />
					<animate begin="indefinite" attributeName="y2" from="300%" to="700%" repeatCount="indefinite" dur="3s" />
					<stop offset="0" stopColor={palette.blue} />
					<stop offset="0.25" stopColor={palette.teal} />
					<stop offset="0.5" stopColor={palette.yellow} />
					<stop offset="0.75" stopColor={palette.teal} />
					<stop offset="1" stopColor={palette.blue} />
				</linearGradient>
				<linearGradient id={`${namespaceId.current}_lg3`} gradientUnits="userSpaceOnUse" x1="300%" y1="0" x2="700%" y2="0" spreadMethod="reflect">
					<animate begin="indefinite" attributeName="x1" from="300%" to="-100%" repeatCount="indefinite" dur="3s" />
					<animate begin="indefinite" attributeName="x2" from="700%" to="300%" repeatCount="indefinite" dur="3s" />
					<stop offset="0" stopColor={palette.blue} />
					<stop offset="0.25" stopColor={palette.teal} />
					<stop offset="0.5" stopColor={palette.yellow} />
					<stop offset="0.75" stopColor={palette.teal} />
					<stop offset="1" stopColor={palette.blue} />
				</linearGradient>

				<linearGradient id={`${namespaceId.current}_lg4`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="400%" spreadMethod="reflect">
					<animate begin="indefinite" attributeName="y1" from="0%" to="-400%" repeatCount="indefinite" dur="3s" />
					<animate begin="indefinite" attributeName="y2" from="400%" to="0%" repeatCount="indefinite" dur="3s" />
					<stop offset="0" stopColor={palette.blue} />
					<stop offset="0.25" stopColor={palette.teal} />
					<stop offset="0.5" stopColor={palette.yellow} />
					<stop offset="0.75" stopColor={palette.teal} />
					<stop offset="1" stopColor={palette.blue} />
				</linearGradient>
			</defs>

			<g strokeWidth="8">
				<path stroke={`url(#${namespaceId.current}_lg1)`} d="M0 0h24" vectorEffect="non-scaling-stroke" />
				<path stroke={`url(#${namespaceId.current}_lg2)`} d="M24 0v24" vectorEffect="non-scaling-stroke" />
				<path stroke={`url(#${namespaceId.current}_lg3)`} d="M24 24H0" vectorEffect="non-scaling-stroke" />
				<path stroke={`url(#${namespaceId.current}_lg4)`} d="M0 24V0" vectorEffect="non-scaling-stroke" />
			</g>
		</svg>;
};
export default AnimatedSvgContainer;